import CustomTable from '@/components/CustomTable/CustomTable.vue';
import NavBar from '@/components/NavBar/NavBar.vue';
import { API_BASE_URL } from "@/config";
import { validateToken } from '@/utils/auth';
import { LOGOUT } from "@/utils/logout.js";
import { format_date } from '@/utils/date_formatter';

export default {
  name: 'ViewAssets',
  mixins: [LOGOUT],
  components: {
    NavBar,
    CustomTable
  },
  data() {
    return {
      data_table: null,
      asset_name: '',
      asset_description: '',
      asset_type: '',
      asset_types: [],
      active_workflows: [],
      asset_file: null,
      image_url: null,
      selected_asset: '',
      selected_workflow_id: null,
      created_asset_id: null,
      is_assigned: false,
      selected_workflow: null,
      show_dropdown: false,
      highlighted_index: 0,
      selected_workflow_name: '',
      search_query: '',
      columns: [
        { label: 'Asset Name', key: 'asset_name' },
        { label: 'Company', key: 'company_name' },
        { label: 'Workflow', key: 'workflow_name' },
        { label: 'Date Created', key: 'date_created' },
        { label: 'Status', key: 'asset_status' },
      ],
      user_role: '',
    };
  },
  methods: {
    formatDate(date) {
      return format_date(date);
    },

    async fetch_assets(page = 1, search = '') {
  const TOKEN = localStorage.getItem('token');
  let url = `${API_BASE_URL}/verify_api/workflow_management_api/get_all_assets/?page=${page}`;
  if (search) {
    url += `&search=${encodeURIComponent(search)}`;
  }
  
  // First, fetch all assets
  const assetsResponse = await new Promise((resolve, reject) => {
    $.ajax({
      url,
      method: 'GET',
      contentType: 'application/json',
      headers: {
        Authorization: `Token ${TOKEN}`
      },
      success: (response) => resolve(response),
      error: (xhr, status, error) => reject(error)
    });
  });

  // Then, fetch workflow data for each asset
  const assetsWithWorkflows = await Promise.all(
    assetsResponse.results.map(async (asset) => {
      try {
        const workflowData = await this.fetch_asset_workflow(asset.id);
        return {
          ...asset,
          workflow_name: workflowData.workflow_name || 'Not Assigned',
          qr_code_exists: workflowData.has_qr_code || false,
          workflow_id: workflowData.workflow_id || null,
          company_name: asset.company_name || asset.company_profile?.company_name || 'N/A'
        };
      } catch (error) {
        // If workflow fetch fails, return asset with default values
        console.error(`Failed to fetch workflow for asset ${asset.id}:`, error);
        return {
          ...asset,
          workflow_name: 'Not Assigned',
          qr_code_exists: false,
          workflow_id: null,
          company_name: asset.company_name || asset.company_profile?.company_name || 'N/A'
        };
      }
    })
  );

  return {
    count: assetsResponse.count,
    results: assetsWithWorkflows
  };
},
    fetch_asset_workflow(asset_id) {
      const TOKEN = localStorage.getItem('token');
      const BASE_URL = API_BASE_URL;
      const GET_ASSET_WORKFLOW_URL = `${BASE_URL}/verify_api/workflow_management_api/get_asset_workflows_api/${asset_id}/`;

      return new Promise((resolve, reject) => {
        $.ajax({
          method: 'GET',
          url: GET_ASSET_WORKFLOW_URL,
          headers: {
            Authorization: `Token ${TOKEN}`,
          },
          success: (response) => {
            if (response.asset_workflows && response.asset_workflows.length > 0) {
              const firstWorkflow = response.asset_workflows[0];
              resolve({
                workflow_name: firstWorkflow.workflow?.workflow_name || null,
                workflow_id: firstWorkflow.workflow?.id || null,
                has_qr_code: firstWorkflow.qr_code?.qr_code ? true : false
              });
            } else {
              resolve({
                workflow_name: null,
                workflow_id: null,
                has_qr_code: false
              });
            }
          },
          error: (error) => {
            reject(error);
          }
        });
      });
    },

    fetch_asset_types() {
      const TOKEN = localStorage.getItem('token');
      const BASE_URL = API_BASE_URL;
      const GET_ASSETS_TYPES_URL = `${BASE_URL}/verify_api/workflow_management_api/get_asset_types/`;

      $.ajax({
        method: 'GET',
        url: GET_ASSETS_TYPES_URL,
        headers: {
          Authorization: `Token ${TOKEN}`,
        },
        success: (response) => {
          this.asset_types = response.asset_types;
        },
        error: (error) => {
          Swal.fire({
            icon: 'error',
            text: error.responseJSON ? error.responseJSON.message : 'An error occurred.',
          });
        }
      });
    },

    get_active_worfklows() {
      const TOKEN = localStorage.getItem('token');
      const BASE_URL = API_BASE_URL;
      const GET_ASSETS_TYPES_URL = `${BASE_URL}/verify_api/workflow_management_api/get_active_workflows_api/`;

      $.ajax({
        method: 'GET',
        url: GET_ASSETS_TYPES_URL,
        headers: {
          Authorization: `Token ${TOKEN}`,
        },
        success: (response) => {
          this.active_workflows = response.active_workflows;
        },
        error: (error) => {
          Swal.fire({
            icon: 'error',
            text: error.responseJSON ? error.responseJSON.message : 'An error occurred.',
          });
        }
      });
    },

    handle_blur(event) {
      if (!this.$refs.searchable_select.contains(event.relatedTarget)) {
        this.show_dropdown = false;
      }
    },

    view_asset(asset_id) {
      this.$router.push({ name: 'view_single_asset', params: { id: asset_id } });
    }
  },

  mounted() {
    if (!validateToken(this.$router)) {
      return;
    }
    
    this.fetch_assets();
    this.fetch_asset_types();
    this.get_active_worfklows();

    document.removeEventListener('click', this.handle_click_outside);
  },

  computed: {
    sorted_active_workflows() {
      return [...this.active_workflows].sort((a, b) =>
        a.workflow_name.localeCompare(b.workflow_name)
      );
    },

    filtered_workflows() {
      if (!this.search_query) {
        return this.sorted_active_workflows;
      }
      return this.sorted_active_workflows.filter(workflow =>
        workflow.workflow_name.toLowerCase().includes(this.search_query.toLowerCase())
      );
    }
  },

  before_destroy() {
    // Revoke the object URL when component is destroyed
    if (this.image_url && this.image_url.startsWith('blob:')) {
      URL.revokeObjectURL(this.image_url);
    }
  },
};